// extracted by mini-css-extract-plugin
export default {"tick":"ToolTip_tick__ZTIzQ","tooltip":"ToolTip_tooltip__KWFqo","small":"ToolTip_small__OG4rK"};